import { BaseModel } from '../email-template/base-model.interface';
import BlockModel from '../email-template/block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface MetaCarouselCtaTextModel extends BaseModel {
  variables?: { [key: string]: string } | MetaCarouselCtaTextVariables;
}

export interface MetaCarouselCtaTextVariables {
  Text: string;
}

export class MetaCarouselCtaTextInitVariables implements MetaCarouselCtaTextVariables {
  Text = '';
}

export class MetaCarouselCtaTextInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new MetaCarouselCtaTextInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
